<div class="tab-content" [class.loading]="loadingSettings">
  <i *ngIf="loadingSettings" class="fa-solid fa-spinner fa-spin tab-loading-spinner"></i>
  <ng-container *ngIf="!loadingSettings">
    <p class="double-margin-bottom">
      Your Retention Policy determines how many recovery points Arpio retains across your account, on a rolling basis.
      Any retained recovery points can be selected for a recovery. Recovery Points will be deleted as they age out of
      this policy. <a href="{{ uiService.retentionDocsUrl }}">Learn More</a>
    </p>
    <form [formGroup]="retentionSettingsFormModel" (ngSubmit)="updateRetentionSettings()">
      <div class="margin-top">
        Always retain the
        <input
          id="recent-retained"
          class="arpio-small-input right-align"
          formControlName="recentRetained"
          size="3"
          focus-element
        />
        most recent recovery points.
      </div>
      <div class="margin-top">
        Also retain 1 recovery point per day for the
        <input id="days-retained" class="arpio-small-input right-align" formControlName="daysRetained" size="3" /> most
        recent days.
      </div>
      <div class="margin-top">
        Also retain 1 recovery point per week for the
        <input id="weeks-retained" class="arpio-small-input right-align" formControlName="weeksRetained" size="3" />
        most recent weeks.
      </div>
      <div class="margin-top">
        Also retain 1 recovery point per month for the
        <input id="months-retained" class="arpio-small-input right-align" formControlName="monthsRetained" size="3" />
        most recent months.
      </div>
      <div class="margin-top">
        Also retain 1 recovery point per quarter for the
        <input
          id="quarters-retained"
          class="arpio-small-input right-align"
          formControlName="quartersRetained"
          size="3"
        />
        most recent quarters.
      </div>
      <button
        *ngIf="canManageRetentionPolicy"
        busy-button
        [busy]="submitting"
        [done]="doneSubmitting"
        type="submit"
        id="update-retention-policy-button"
        class="arpio-button margin-top"
        [disabled]="updateButtonDisabled"
        (click)="updateRetentionSettings()"
      >
        UPDATE
      </button>
    </form>
  </ng-container>

  <modal-dialog #releaseRpsDialog [dialogTemplate]="releaseRpsDialogTemplate"></modal-dialog>

  <ng-template #releaseRpsDialogTemplate>
    <div class="flex-center-column full-width">
      <confirm-action-dialog
        action="Release"
        name="Recovery Points"
        [error]="null"
        (onCancel)="dismissReleaseModal()"
        (onAction)="unprotectRps()"
        [busy]="unprotecting"
      >
        <div class="error margin-top">
          Note: After the Recovery Points are released they are eligible for clean up and may be deleted by
          {{ productName }}
        </div>
      </confirm-action-dialog>
    </div>
  </ng-template>

  <ng-container *ngIf="showRetainedRps">
    <h2 class="margin-top">Indefinitely-Retained Recovery Points</h2>
    <p>These Recovery Points are exempt from clean up even if they don't match the retention policy.</p>

    <div class="card flex justify-content-center table-container" style="max-width: 60rem">
      <p-table
        #dt1
        [value]="retainedRps"
        sortField="applicationName"
        sortMode="multiple"
        selectionMode="multiple"
        [(selection)]="selectedRps"
        [globalFilterFields]="globalFilterFields"
        dataKey="rp.recoveryPointId"
        [scrollable]="true"
        scrollHeight="flex"
        [resizableColumns]="true"
        [tableStyle]="{ 'min-width': '30rem', 'max-width': '60rem' }"
        styleClass="p-datatable-sm arpio-table"
        [rowHover]="true"
        [totalRecords]="retainedRps?.length"
        [paginator]="true"
        overflow="auto"
        [showLoader]="false"
        [loading]="loadingRetainedRps"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 100]"
      >
        <ng-template pTemplate="loadingbody">
          <tr>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
          </tr>
          <tr>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
          </tr>
        </ng-template>

        <ng-template pTemplate="caption">
          <div class="flex-row flex-center-row">
            <p-button
              *ngIf="canManageRetentionPolicy"
              [rounded]="true"
              pRipple
              severity="danger"
              icon="fa-utility fa-semibold fa-unlock"
              (click)="releaseRpsClick()"
              [label]="releaseButtonText"
              size="small"
              [disabled]="unprotectDisabled"
            ></p-button>
            <p-iconfield size="small" iconPosition="right">
              <input
                pInputText
                #filterInput
                size="small"
                type="text"
                (input)="dt1.filterGlobal($event.target.value, 'contains')"
                placeholder="Filter..."
              />
              <p-inputicon>
                <i class="fa-utility-fill fa-semibold fa-filter fade-icon"></i>
              </p-inputicon>
            </p-iconfield>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
            <th pSortableColumn="applicationName" class="strong-text">
              <div class="strong-text">Application <p-sortIcon field="applicationName"></p-sortIcon></div>
            </th>
            <th pSortableColumn="timestampString" class="strong-text">
              <div class="strong-text">Timestamp <p-sortIcon field="timestampString"></p-sortIcon></div>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rpr>
          <tr>
            <td>
              <p-tableCheckbox [value]="rpr" />
            </td>
            <td>
              <span>{{ rpr.applicationName }}</span>
            </td>
            <td>
              <span>{{ rpr.timestampString }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-container>
</div>
